import * as constants from './constants';
import {API_CADIMO5, API_VENDAS} from './constants';
import RequestUtils from "../../services/requestUtils";
import BaseServices from "../../helpers/BaseServices";

export default class Services extends BaseServices {
    constructor() {
        super(API_VENDAS, API_CADIMO5);
    };

    busca = (modalidade, finalidade, tipo, endereco, filtros = [], page, order = 'menor-valor', limit = 10, offset = 0 ,caracSelecionados = [], caracSelecionadosCondominio = [], destaque) => {

        let currentPage = (page ? page : 1);
        let pageOffset = (Array.isArray(offset) ? 0 : offset);

        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('busca', modalidade);

        url += `${method}?limit=${limit}&offset=${pageOffset}&page=${currentPage}`;

        if (tipo) {
            url += `&tipo=${tipo.replace('-', ' ')}`;
        }

        if (endereco) {
            url += `&endereco=${endereco}`;
        }

        if (finalidade) {
            url += `&finalidade=${finalidade}`;
        }

        if (filtros) {
            for (let i in filtros) {
                if (
                filtros[i] === '' || filtros[i] === null || filtros[i] === undefined || filtros[i] === 0 || 
                filtros[i] === constants.PRICE_RENT_INITIAL[1] || 
                filtros[i] === constants.PRICE_SALE_INITIAL[1] ||
                filtros[i] === constants.AREA_INITIAL[1]) continue;
                url += `&${i}=${filtros[i]}`;
            }
        }

        if (caracSelecionados.length > 0) {
            let list = caracSelecionados.map(item => [
                item.value
            ]);
            url += `&caracteristicas=${list}`;
        }
        
        if (caracSelecionadosCondominio.length > 0) {   
            let list = caracSelecionadosCondominio.map(item => [
                item.value
            ]);
            url += `&caracsCondominio=${list}`;
        }

        if (destaque) {
            url += `&destaque=${destaque.replace(/-/g, ' ')}`;
        }


        return fetch(url, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }

                return response.json();
            });
    };

    getCaracteristicasImovel = (modalidade, tipo) => {
        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('caracteristicas', modalidade);

        return fetch(`${url}${method}/${tipo}`, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }
                return response.json();
            });
    }

    getCaracteristicasCondominio = (modalidade, tipo) => {
        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('caracteristicasCondominio', modalidade);

        return fetch(`${url}${method}/${tipo}`, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }
                return response.json();
            });
    }

    getTiposImoveisOptions = (modalidade) => {
        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('tipos', modalidade);

        return fetch(`${url}${method}`, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }

                return response.json();
            });
    }

    getTiposImoveisPorFinalidadeOptions = (modalidade) => {
        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('tipos-finalidade', modalidade);

        return fetch(`${url}${method}`, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }

                return response.json();
            });
    }

    getbuscaEndereco = (modalidade, palavra) => {
        let url = RequestUtils.uriResolver(modalidade);
        let method = RequestUtils.methodResolver('buscaEndereco', modalidade);

        return fetch(`${url}${method}${palavra}`, BaseServices._getRequestInfo(modalidade))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }

                return response.json();
            });
    }
}
